import useSWR from "swr";

interface DiscountPopupConfigData {
  id: string;
  promotion: {
    id: string;
    code: string;
    offerValue: string;
    offerType: "percentage";
  };
  imageUrl: string;
}

export function usePartnerDiscountPopupQuery(partnerId: string): {
  data: DiscountPopupConfigData | undefined;
} {
  const { data } = useSWR(
    `/api/v3/partners/${partnerId}/discount_popup_configs`
  );

  return { data: toDiscountPopupConfig(data?.data) };
}

function toDiscountPopupConfig(data: any): DiscountPopupConfigData | undefined {
  if (data) {
    return {
      id: data.id,
      promotion: {
        id: data.promotion.id,
        code: data.promotion.code,
        offerValue: data.promotion.offer_value,
        offerType: data.promotion.offer_type,
      },
      imageUrl: data.image_url,
    };
  }
}
